import { useMutation } from '@tanstack/react-query';
import { createPortalSession } from '../../../services/pricing/PricingService';

export const useCreatePortalSession = () => {
  return useMutation({
    mutationFn: (subscriptionIds?: string[]) => createPortalSession(subscriptionIds),
  });
};